<template>
  <div class="home-page-container d-flex flex-column min-vh-100">
    <!-- Header Navigation -->
    <Header />

    <!-- Main Content Area -->
    <main class="home-main-wrapper flex-grow-1">
      <!-- ============================================
           GUEST HOME (Chua dang nhap)
           ============================================ -->
      <div v-if="showHomeSections && !isLoggedIn" class="guest-home-wrapper">
        <!-- CTA Banner (Guest) -->
        <section class="cta-banner-section">
          <div class="container">
            <div class="cta-banner-card">
              <div class="cta-inner">
                <!-- Left Story Column -->
                <div class="cta-text-col">
                  <div class="cta-eyebrow">
                    <icon icon="fa-solid fa-wand-magic-sparkles" class="cta-eyebrow-icon me-1.5" />
                    <span>Không gian văn hóa đọc</span>
                  </div>
                  <h2 class="cta-headline">
                    Lối Đọc: Mạng xã hội cho người yêu sách
                  </h2>
                  <p class="cta-sub">
                    Nơi bạn dễ dàng tìm đúng cuốn sách hợp gu qua hệ thống gợi ý thông minh, cá nhân hóa tủ sách, ghi chú trích dẫn mỗi ngày và kết nối mua bán sách cũ an toàn.
                  </p>
                  <div class="cta-buttons">
                    <router-link to="/register" class="btn-cta-primary">
                      <icon icon="fa-solid fa-user-plus" class="me-2" />
                      <span>Đăng ký ngay</span>
                    </router-link>
                    <router-link to="/smart-recommendation" class="btn-cta-secondary">
                      <icon icon="fa-solid fa-wand-magic-sparkles" class="me-2" />
                      <span>Thử gợi ý thông minh</span>
                    </router-link>
                  </div>
                </div>

                <!-- Right Feature Grid -->
                <div class="cta-features-grid">
                  <div class="cta-feature-card">
                    <div class="cta-card-icon icon-compass">
                      <icon icon="fa-solid fa-compass" />
                    </div>
                    <div class="cta-card-content">
                      <h3 class="cta-card-title">Gợi ý chuẩn gu</h3>
                      <p class="cta-card-desc">Nhận đề xuất sách theo từng thể loại, cảm xúc và yêu cầu đọc cá nhân.</p>
                    </div>
                  </div>

                  <div class="cta-feature-card">
                    <div class="cta-card-icon icon-review">
                      <icon icon="fa-solid fa-feather-pointed" />
                    </div>
                    <div class="cta-card-content">
                      <h3 class="cta-card-title">Khám phá &amp; đánh giá</h3>
                      <p class="cta-card-desc">Tìm sách hay, chấm điểm và viết nhận xét chân thực từ cộng đồng.</p>
                    </div>
                  </div>

                  <div class="cta-feature-card">
                    <div class="cta-card-icon icon-bookmark">
                      <icon icon="fa-solid fa-book-bookmark" />
                    </div>
                    <div class="cta-card-content">
                      <h3 class="cta-card-title">Theo dõi hành trình đọc</h3>
                      <p class="cta-card-desc">Quản lý tủ sách cá nhân, tiến độ trang đọc và trích dẫn tâm đắc.</p>
                    </div>
                  </div>

                  <div class="cta-feature-card">
                    <div class="cta-card-icon icon-exchange">
                      <icon icon="fa-solid fa-repeat" />
                    </div>
                    <div class="cta-card-content">
                      <h3 class="cta-card-title">Sàn mua bán sách cũ</h3>
                      <p class="cta-card-desc">Mua bán sách cũ tiện lợi, minh bạch với cơ chế bảo vệ an tâm.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- Trending Books (Guest) -->
        <section class="home-section trending-section py-5">
          <div class="container">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div>
                <h2 class="section-title h4 font-serif fw-bold m-0">
                  <icon icon="fa-solid fa-arrow-trend-up" class="me-2 text-danger" />
                  Sách đang thịnh hành
                </h2>
              </div>
              <button class="btn-see-all-link" @click="viewAllBooks">
                Xem tất cả <icon icon="fa-solid fa-arrow-right" class="ms-1" />
              </button>
            </div>
            <div v-if="isTrendingLoading" class="recommendations-grid">
              <div v-for="n in trendingSkeletonCount" :key="'gts-' + n" class="book-hscroll-card">
                <div class="skeleton-item" style="height:200px;border-radius:8px;margin-bottom:10px"></div>
                <div class="skeleton-item skeleton-title mb-1"></div>
                <div class="skeleton-item skeleton-text"></div>
              </div>
            </div>
            <div v-else-if="trendingBooks.length > 0" class="recommendations-grid">
              <div v-for="book in trendingBooksDisplay" :key="'gtrend-' + book.id">
                <BookCard
                  :item="book"
                  mode="catalog"
                  @click="handleCardClick(book.id)"
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- ============================================
           USER HOME (Da dang nhap)
           ============================================ -->
      <div v-if="showHomeSections && isLoggedIn" class="user-home-wrapper">

        <!-- Trending Books (User) -->
        <section class="home-section trending-section py-5">
          <div class="container">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div>
                <h2 class="section-title h4 font-serif fw-bold m-0">
                  <icon icon="fa-solid fa-arrow-trend-up" class="me-2 text-danger" />
                  Sách đang thịnh hành
                </h2>
              </div>
              <button class="btn-see-all-link" @click="viewAllBooks">
                Xem tất cả <icon icon="fa-solid fa-arrow-right" class="ms-1" />
              </button>
            </div>
            <div v-if="isTrendingLoading" class="recommendations-grid">
              <div v-for="n in trendingSkeletonCount" :key="'uts-' + n" class="book-hscroll-card">
                <div class="skeleton-item" style="height:200px;border-radius:8px;margin-bottom:10px"></div>
                <div class="skeleton-item skeleton-title mb-1"></div>
                <div class="skeleton-item skeleton-text"></div>
              </div>
            </div>
            <div v-else-if="trendingBooks.length > 0" class="recommendations-grid">
              <div v-for="book in trendingBooksDisplay" :key="'utrend-' + book.id">
                <BookCard
                  :item="book"
                  mode="catalog"
                  @click="handleCardClick(book.id)"
                />
              </div>
            </div>
          </div>
        </section>

        <!-- Recommendations (User) -->
        <section v-if="showRecommendations" class="home-section recommendations-section py-5">
          <div class="container">
            <div class="d-flex align-items-start justify-content-between mb-4">
              <div>
                <h2 class="section-title h4 font-serif fw-bold m-0">
                  <icon icon="fa-solid fa-wand-magic-sparkles" class="me-2 text-primary-color" />
                  Đề xuất dành cho bạn
                </h2>
                <p class="text-muted fs-7 m-0 mt-1">Những cuốn sách bạn có thể sẽ yêu thích</p>
              </div>
              <button
                class="btn-refresh-recommend"
                :class="{ 'is-spinning': isRefreshingRecommend || isRecommendLoading }"
                :disabled="isRefreshingRecommend || isRecommendLoading"
                @click="refreshRecommendedBooks"
                title="Làm mới sách đề xuất"
              >
                <icon icon="fa-solid fa-arrows-rotate" class="refresh-icon me-1" />
                <span class="refresh-label">Làm mới đề xuất</span>
              </button>
            </div>
            <div v-if="isRecommendLoading" class="recommendations-grid">
              <div v-for="n in recommendSkeletonCount" :key="'rs-' + n" class="book-hscroll-card">
                <div class="skeleton-item" style="height:200px;border-radius:8px;margin-bottom:10px"></div>
                <div class="skeleton-item skeleton-title mb-1"></div>
                <div class="skeleton-item skeleton-text"></div>
              </div>
            </div>
            <div v-else-if="recommendedBooks.length > 0" class="recommendations-grid">
              <div v-for="book in recommendedBooksDisplay" :key="'rec-' + book.id">
                <BookCard
                  :item="book"
                  mode="catalog"
                  @click="handleCardClick(book.id)"
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- Search Results Area -->
      <section v-if="!showHomeSections" class="results-display-section py-5">
        <div class="container px-3">

        <!-- SKELETON LOADING STATE -->
        <div v-if="isLoading" class="skeleton-grid-container py-4 fade-in">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="skeleton-item skeleton-text-short"></div>
            <div class="skeleton-item skeleton-text-micro"></div>
          </div>
          <div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-2 g-sm-3 g-md-4">
            <div v-for="n in 10" :key="n" class="col">
              <div class="skeleton-card">
                <div class="skeleton-image-wrapper">
                  <div class="skeleton-item skeleton-cover"></div>
                </div>
                <div class="skeleton-content p-3">
                  <div class="skeleton-item skeleton-title mb-2"></div>
                  <div class="skeleton-item skeleton-text mb-3"></div>
                  <div class="skeleton-item skeleton-rating mb-2"></div>
                  <div class="skeleton-item skeleton-button"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ERROR STATE -->
        <div v-if="errorMessage && !isLoading" class="state-container text-center py-5 fade-in">
          <div class="error-illustration-wrapper mb-4">
            <icon icon="fa-solid fa-triangle-exclamation" class="display-1 text-danger" />
          </div>
          <h3 class="font-serif fw-bold text-danger mb-2">Đã xảy ra lỗi</h3>
          <p class="text-muted max-width-sm mx-auto mb-4">
            {{ errorMessage }}
          </p>
          <button @click="retrySearch" class="btn btn-outline-danger px-4 rounded-pill">
            <icon icon="fa-solid fa-arrows-rotate" class="me-2" />
            Thử lại
          </button>
        </div>

        <!-- NOT FOUND STATE (404) -->
        <div v-if="books.length === 0 && !isLoading && !errorMessage" class="state-container text-center py-5 fade-in">
          <div class="not-found-illustration mb-4">
            <icon icon="fa-solid fa-book-open-reader" class="display-1 text-muted" />
          </div>
          <h3 class="font-serif fw-bold text-primary-color mb-2">Không tìm thấy sách</h3>
          <p class="text-muted max-width-sm mx-auto">
            <span v-if="searchedKey">Không có kết quả phù hợp với từ khóa <strong class="text-primary-color">"{{ searchedKey }}"</strong>. Vui lòng kiểm tra lại chính tả hoặc thử một từ khóa khác.</span>
            <span v-else>Thư viện hiện tại chưa có dữ liệu sách. Vui lòng quay lại sau!</span>
          </p>
        </div>

        <!-- SUCCESS RESULT LIST -->
        <div v-if="books.length > 0 && !isLoading && !errorMessage" class="results-success-wrapper fade-in">
          <!-- Results Header Info -->
          <div class="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between mb-4 border-bottom pb-3">
            <div class="text-start">
              <h4 class="h5 text-primary-color font-serif m-0">
                <span v-if="$route.path === '/trending' || $route.query.type === 'trending'">
                  <icon icon="fa-solid fa-arrow-trend-up" class="me-2 text-danger" />Sách đang thịnh hành
                </span>
                <span v-else-if="searchedKey">Kết quả tìm kiếm cho: <strong class="italic">"{{ searchedKey }}"</strong></span>
                <span v-else>Khám phá kho sách gợi ý</span>
              </h4>
              <span v-if="$route.path === '/trending' || $route.query.type === 'trending'" class="fs-7 text-muted">Tổng số {{ totalElements }} cuốn sách thịnh hành</span>
              <span v-else-if="searchedKey" class="fs-7 text-muted">Tìm thấy {{ totalElements }} cuốn sách phù hợp</span>
              <span v-else class="fs-7 text-muted">Tổng số {{ totalElements }} cuốn sách gợi ý hôm nay</span>
            </div>
            <div class="text-start text-sm-end mt-2 mt-sm-0 fs-7 text-muted">
              Trang {{ currentPage + 1 }} / {{ totalPages }}
            </div>
          </div>

          <!-- Book Grid (2 columns on mobile, 3 on iPad, 4-5 on desktop) -->
          <div class="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-2 g-sm-3 g-md-4">
            <div v-for="book in books" :key="book.id" class="col">
              <BookCard
                :item="book"
                mode="catalog"
                @click="$router.push('/book/' + book.id)"
              />
            </div>
          </div>

          <!-- Pagination Controls -->
          <nav v-if="totalPages > 1" class="d-flex justify-content-center mt-5" aria-label="Book search navigation">
            <ul class="custom-pagination d-flex align-items-center gap-1 list-unstyled p-1.5 rounded-pill shadow-sm">
              <!-- Previous Button -->
              <li class="page-item-custom">
                <button
                  @click="goToPage(currentPage - 1)"
                  :disabled="currentPage === 0"
                  class="page-link-custom prev-next-btn d-flex align-items-center justify-content-center"
                  aria-label="Trang trước"
                >
                  <icon icon="fa-solid fa-chevron-left" />
                </button>
              </li>

              <!-- Numeric page links -->
              <li
                v-for="page in visiblePages"
                :key="page"
                class="page-item-custom"
              >
                <!-- Ellipsis placeholder -->
                <span v-if="page === '...'" class="page-link-ellipsis">...</span>
                <!-- Page link button -->
                <button
                  v-else
                  @click="goToPage(page)"
                  :class="['page-link-custom numeric-btn d-flex align-items-center justify-content-center', { 'active': currentPage === page }]"
                >
                  {{ page + 1 }}
                </button>
              </li>

              <!-- Next Button -->
              <li class="page-item-custom">
                <button
                  @click="goToPage(currentPage + 1)"
                  :disabled="currentPage === totalPages - 1"
                  class="page-link-custom prev-next-btn d-flex align-items-center justify-content-center"
                  aria-label="Trang sau"
                >
                  <icon icon="fa-solid fa-chevron-right" />
                </button>
              </li>
            </ul>
          </nav>
        </div>
        </div>

      </section>
    </main>

    <!-- Footer -->
    <Footer />

  </div>
</template>

<script src="./home.js"></script>
<style scoped src="./home.css"></style>